module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/logo@2x-58ea2ff15980ce683f3105e85e52f574.png";